import React from "react";
import { Cloud, Server, Terminal, Wrench } from "lucide-react";
import { skills } from "../data/mock";

const categoryIcons = {
  "Cloud & Infrastructure": Cloud,
  "Systems & Networking": Server,
  "Programming & Automation": Terminal,
  "Tools": Wrench,
};

const categoryDescriptions = {
  "Cloud & Infrastructure": "Enterprise cloud platforms and virtualization",
  "Systems & Networking": "Network design, security, and administration",
  "Programming & Automation": "Scripting and database management",
  "Tools": "Productivity and creative software",
};

const Skills = () => {
  const categories = Object.entries(skills);

  return (
    <section id="skills" className="relative py-24 sm:py-32">
      {/* Top divider */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-zinc-800 to-transparent" />

      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="mb-16">
          <p className="text-blue-400 text-sm font-medium font-mono tracking-wide mb-3">
            02 — Skills
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight mb-4">
            Technical Expertise
          </h2>
          <p className="text-zinc-500 text-base max-w-lg">
            Core competencies across cloud, networking, systems administration, and automation.
          </p>
        </div>

        {/* Skills Grid */}
        <div className="grid sm:grid-cols-2 gap-5">
          {categories.map(([category, items], index) => {
            const IconComponent = categoryIcons[category] || Wrench;
            const description = categoryDescriptions[category] || "";

            return (
              <div
                key={category}
                className="group relative p-6 sm:p-8 rounded-xl bg-white/[0.02] border border-white/5 hover:border-blue-500/15 transition-all duration-300 hover:bg-blue-500/[0.02]"
              >
                {/* Category number */}
                <div className="absolute top-5 right-5 text-[10px] font-mono text-zinc-700">
                  0{index + 1}
                </div>

                {/* Icon + Title */}
                <div className="flex items-start gap-3.5 mb-2">
                  <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-blue-500/8 border border-blue-500/10 flex items-center justify-center group-hover:bg-blue-500/12 transition-colors duration-300">
                    <IconComponent size={18} className="text-blue-400" />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-white">
                      {category}
                    </h3>
                    <p className="text-xs text-zinc-600 mt-0.5">{description}</p>
                  </div>
                </div>

                {/* Skill Tags */}
                <div className="flex flex-wrap gap-2 mt-5">
                  {items.map((skill) => (
                    <span
                      key={skill}
                      className="inline-block px-3 py-1.5 text-xs font-medium text-zinc-400 bg-white/[0.03] border border-white/5 rounded-md hover:text-zinc-300 hover:border-white/10 transition-all duration-200"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Skills;
